export const WITHDRAWAL_MONEY_REQUEST_POPUP_EVENTS = {
  OPEN: 'withdrawal-money-request-popup-open',
  CLOSE: 'withdrawal-money-request-popup-close',
};
